import { numFormmater } from "@/pages/Requirement/util";
import dayjs, { Dayjs } from "dayjs";

export const priceFormat: (val: string | undefined) => string = val => {
  let value = Number(val);
  if (value) {
    return numFormmater(value)
  } else {
    return '0'
  }
}

export const dateFormat: (value: Dayjs, isShowTime?: boolean) => string = (value, isShowTime = false) => {
  if (isShowTime) {
    return dayjs(value).format("YYYY-MM-DD HH:mm")
  } else {
    return dayjs(value).format("YYYY-MM-DD")
  }
}